<template>
    <div class="footer modulewrap">
        <div class="copyright realwrap">
            <ffcontent alias="gen_footer"></ffcontent>
        </div>
    </div>
</template>
